var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13797 4.125C5.89313 4.125 4.88401 5.13234 4.88401 6.375C4.88401 7.61766 5.89313 8.625 7.13797 8.625C8.38282 8.625 9.39194 7.61766 9.39194 6.375C9.39194 5.13234 8.38235 4.125 7.13797 4.125ZM20.9951 0H2.96345C1.34576 0 0 1.34297 0 3V18C0 19.657 1.34533 21 2.96302 21H20.9947C22.6547 21 24 19.657 24 18V3C24.0004 1.34297 22.695 0 20.9951 0ZM21.7465 17.6859L15.3227 8.97187C15.2053 8.75625 14.9376 8.625 14.6512 8.625C14.3641 8.625 14.0961 8.75475 13.937 8.97089L8.93128 15.7256L7.18963 13.5646C7.02805 13.3641 6.77011 13.2455 6.49606 13.2455C6.22174 13.2455 5.96404 13.364 5.80203 13.5646L2.2558 17.962C2.2558 17.9606 2.2558 17.9634 2.2558 17.962L2.25392 3C2.25392 2.58647 2.59098 2.25 3.00524 2.25H21.0369C21.4512 2.25 21.7883 2.58647 21.7883 3V17.6859H21.7465Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/defaultImg.de091ccdc652a74b2526345bd959001b.svg";
export { ForwardRef as ReactComponent };